/* eslint-disable max-len */
import { useEffect } from 'react';
import sendGTMEvent from '../../helpers/sendGTMEvent';
import { getEventObject } from '../helpers/gtmEventHelpers';
import { fetchPackages } from '../services/DiveWirePurchaseService';

const useBulkPurchaseEffects = ({
  state,
  cardFields,
  dispatch,
  handlePackageSelect,
}) => {
  const {
    pressReleasePackageAPIUrl,
  } = window.bulkPurchaseCodeCheckoutFlow;

  // once we have a valid payment info trigger the add_payment_info event
  useEffect(() => {
    const paymentInfoIsValid = cardFields.cardNumber.completed && cardFields.cardExpiry.completed && cardFields.cardCVC.completed;
    if (paymentInfoIsValid) {
      sendGTMEvent(getEventObject(state.activePackageObject, state.paymentIntentId, state.numPressReleases), 'add_payment_info');
    }
  }, [cardFields]);

  // Sets package state initially using the API call data
  useEffect(() => {
    fetchPackages(pressReleasePackageAPIUrl, (data) => dispatch({ type: 'setPackages', value: data }));
  }, []);

  // Sets active package on page load
  useEffect(() => {
    state.packages.map((pkg) => pkg.is_most_popular && handlePackageSelect(pkg.pk, pkg.minimum_quantity));
  }, [state.packages]);
  // Scrolls to top on contact form if the next button was pressed
  useEffect(() => {

  }, [state.scrollToContactInfo]);

  // Scrolls to top-most error if the validation errors are present on the form
  useEffect(() => {
    if (state.scrollToTopmostError) {
      if (document.querySelector('.form-error__highlight')) {
        const navBarOffset = document.getElementsByClassName('site-menu')[0]?.clientHeight ?? 0;
        const paddingOffset = 10;
        const topMostErrorY = document.querySelector('.form-error__highlight').closest('label')?.offsetTop
          ?? document.querySelector('.form-error__highlight')?.offsetTop
          ?? 10;
        const scrollPositionTop = topMostErrorY - navBarOffset - paddingOffset;
        window.scrollTo({ top: scrollPositionTop, left: 0, behavior: 'smooth' });
        dispatch({ type: 'setScrollToTopmostError', value: !state.scrollToTopmostError });
      }
      dispatch({ type: 'setScrollToTopmostError', value: false });
    }
  }, [state.scrollToTopmostError]);
};

export default useBulkPurchaseEffects;
